import {Attrs, MinzeElement, Reactive} from "minze";

export interface TjResultCardNextIcon {
  dataColor?: string
}

export class TjResultCardNextIcon extends MinzeElement {
  attrs: Attrs = ["data-color"]
  reactive: Reactive = ["color"]

  static observedAttributes = ["data-color"]

  onAttributeChange = (name: string) => {
    if (name === "data-color") {
      this.color = this.dataColor || "#068FC3"
    }
  };

  html = () => `
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.2967 13.1085C12.1431 12.8632 7.60726 13.1669 1.01594 13.8094C0.339665 13.8753 0.0580118 13.1577 0.674093 12.8954C3.54631 11.6726 7.77238 11.0615 17.1151 10.6357C17.2676 10.6288 17.3357 10.4534 17.2163 10.3667L11.8717 6.48315C11.4222 6.15647 11.2834 5.58877 11.5384 5.11937C11.8532 4.53982 12.6439 4.32582 13.2548 4.65568C17.3472 6.86554 20.0109 8.43733 23.8055 11.0211C24.4551 11.4633 24.5099 12.3292 23.9413 12.8559C21.4484 15.1654 19.9208 17.0368 17.8673 19.9956C17.5113 20.5085 16.7597 20.6569 16.207 20.3177C15.6488 19.9752 15.5203 19.2767 15.9254 18.7873L20.4265 13.3499C20.5072 13.2524 20.4308 13.1125 20.2967 13.1085Z" fill="${this.color|| "#068FC3"}"/>
    </svg>
  `;

  css = () => `
    
  `;
}
